import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

interface HrmsApiLogState {
  data: any | null;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}

const initialState: HrmsApiLogState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getHrmsApiLogData: any = createAsyncThunk(
  "hrms/api-logs",
  async (requestBody: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.HRMS_API_LOGS,
        requestBody
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const hrmsApiLogSlice = createSlice({
  name: "hrmsApiLog",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHrmsApiLogData.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "list";
      })
      .addCase(getHrmsApiLogData.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getHrmsApiLogData.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload;
      });
  },
});

export const { resetAll } = hrmsApiLogSlice.actions;
export default hrmsApiLogSlice.reducer;

